import { List } from '@mui/material';

import { selectCurrentUser } from '@src/store/auth/auth-selectors';
import { useAppSelector } from '@src/store/store';

import useLocales from '@src/locales/use-locales';
import { getAllowedRoutes } from '@src/routes/utils/navigation';

import useNavItems from '../../config-navigation';
import NavGroupMini from '../nav-group-mini';

const NavListMini = () => {
  const user = useAppSelector(selectCurrentUser);
  const { t } = useLocales();

  const { role } = user!;

  const navItems = useNavItems();
  const filteredNavItems = getAllowedRoutes(navItems, role);

  return (
    <List
      aria-label={t('ariaLabels.navList')}
      sx={{ p: 0, display: 'flex', flexDirection: 'column', gap: 2 }}
    >
      {filteredNavItems.map((entry) => (
        <NavGroupMini key={entry.id} group={entry} />
      ))}
    </List>
  );
};

export default NavListMini;
